export const configuration = {
  termsLink: 'https://upwex.io/terms-of-use/',
  privacyPolicyLink: 'https://upwex.io/privacy-policy/'
};